import { createContext, useContext, useState } from "react"
import { Modal, Button } from "react-bootstrap"
import { Outlet } from "react-router-dom"

// Create Context
const ModalContext = createContext()

export const ModalProvider = () => {
  const [modal, setModal] = useState({
    show: false,
    title: null,
    body: null,
  })

  const openModal = ({ title, body }) => {
    setModal({ show: true, title, body })
  }

  const closeModal = () => {
    setModal({ show: false, title: null, body: null })
  }

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      <Outlet />

      {/* Global Modal */}
      <Modal show={modal.show} onHide={closeModal} centered>
        <Modal.Header className="border-0 p-0 mb-2">
          <Modal.Title className="fs-5 fw-bold">{modal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 text-muted fs-7 mb-3">{modal.body}</Modal.Body>
        <Modal.Footer className="p-0 border-0">
          <Button className="bg-white rounded-3 shadow-btn border-light fs-7 px-3" variant="" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </ModalContext.Provider>
  )
}

export const useModal = () => useContext(ModalContext)
